import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=6d4edcf0&scoped=true"
var script = {}
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=6d4edcf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4edcf0",
  null
  
)

export default component.exports